// Na desktopu skroluje unutrašnji kontejner, a na mobilnom cela stranica (da bi browser sakrio svoje trake).
// Zaglavlje + navigacija su sticky na mobilnom, pa se od pozicije oduzima njihova visina.
const MOBILE_STICKY_HEIGHT = 106;

const isInnerScroller = (el: HTMLElement | null) => !!el && el.scrollHeight > el.clientHeight + 1;

export const scrollToChild = (parent: HTMLElement | null, child: HTMLElement | null, behavior: ScrollBehavior = 'auto', gap = 0) => {
    if (!child) return;
    if (parent && isInnerScroller(parent)) {
        const offset = child.getBoundingClientRect().top - parent.getBoundingClientRect().top;
        parent.scrollTo({ top: parent.scrollTop + offset - gap, behavior });
        return;
    }
    const sticky = window.innerWidth < 1024 ? MOBILE_STICKY_HEIGHT : 0;
    window.scrollTo({ top: window.scrollY + child.getBoundingClientRect().top - sticky - gap, behavior });
};

export const scrollToY = (parent: HTMLElement | null, top: number, behavior: ScrollBehavior = 'auto') => {
    if (parent && isInnerScroller(parent)) {
        parent.scrollTo({ top, behavior });
        return;
    }
    window.scrollTo({ top, behavior });
};
